import React from 'react';
import { StyledLabel, StyledSelect, SelectContainer } from './style';

export const Select = ({ value, name, onChange, options, label }) => {
    const selectOptions = options.map(option => (
        <option key={option.label} value={option.value}>
            {option.label}
        </option>
    ));

    return (
        <div>
            {label && <StyledLabel>{label}</StyledLabel>}
            <SelectContainer>
                <StyledSelect name={name} value={value} onChange={onChange}>
                    {selectOptions}
                </StyledSelect>
            </SelectContainer>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Components/Inputs/CreateEditInput/Select.js